<i18n>
{
    "uk": {
        "title": "Роботи студентів"
    },
    "en": {
        "title": "Students works"
    }
}
</i18n>

<template>
    <section
        v-if="(block.cases && block.cases.length) || edit"
        :id="block.id || `${block.type}-${uid}`"
        class="mt-6 mt-md-8 mt-lg-10"
    >
        <div class="page-container">
            <div
                v-if="edit"
                class="edit"
            >
                <button
                    class="btn-bg btn-lg rounded icon-ic-pencil-outline elevate edit-btn"
                    @click="$emit('openEditor')"
                />
            </div>

            <h2 class="ta-center h4 h3-sm h2-md fw-800 fw-sm-700">
                {{ block.title || $t('title', locale)}}
            </h2>
            <div
                v-if="block.description"
                v-html="block.description"
                class="ta-center f-sm-semilarge  mt-2 mx-auto lp-description"
            />
        </div>


        <Side-scroll class="l-cases center-arrows">
            <Case
                v-for="(post, i) in block.cases"
                :key="`post-${post.id}`"
                :post="post"
                :disableActions="true"
                target="_blank"
                :class="{
                    'ml-md-2': i != 0,
                    'mr-1': i != (block.cases.length - 1)
                }"
                class="static scroll-item"
            />
        </Side-scroll>
    </section>
</template>

<script>
    import Card       from '~/components/cards/Card.vue';
    import SideScroll from '~/components/SideScroll.vue';
    import Case       from '~/components/thumbnails/Case.vue';

    import { useCourseLandingStore } from '~/stores/courseLanding';

    let uid = 0;

    export default {
        props: {
            block: Object,
            edit:  Boolean,
        },

        components: {
            Card,
            SideScroll,
            Case
        },

        data () {
            uid++;

            return {
                uid
            };
        },

        computed: {
            locale () {
                return this.courseLandingStore.locale;
            },

            courseLandingStore () {
                return useCourseLandingStore();
            },
        },
    };
</script>

<style scoped>
    .lp-description {
        max-width: 673px;
    }

    :deep(.lp-description a) {
        font-weight: 700;
    }

    .l-cases {
        margin-top: 12px;
    }

    .edit {
        position: relative;
    }

    .edit-btn {
        position: absolute;
        top:      -6px;
        right:    -8px;
        z-index:  10;
    }
</style>